module.exports = __webpack_public_path__ + "bin/741de1ea1ea2e04e2cfbc5db3c1bf0aa.png";